import React, { FC, useEffect, useState } from 'react';
import ISection from '../../../../../../../model/ISection';
import SectionStatesWrapper from '../../../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import { useSelectedFeatures } from '../../../../../../../hooks/features/useSelectedFeatures';
import SelectedFeaturesList from './SelectedFeaturesList';
import SelectedFeatureCategoryList from './SelectedFeatureCategoryList';
import { GetCustomizeCar_customizeCar_prices_totalPrice_taxes } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import FeesAndCharges from './FeesAndCharges';
import CategoryPurpose from '../../../../../../../enum/CategoryPurpose';
import useCustomizeCarContext from '../../../../../../../hooks/useCustomizeCarContext';
import Discounts from './Discounts';

const SelectedFeaturesContainer: FC = () => {
  const { loading, error, selectedCar } = useCustomizeCarContext();
  const { selectedFeatures, selectedMiscFeatures, selectedMiscOffers } = useSelectedFeatures();
  const basketDiscounts = selectedCar.prices.discounts;
  const [taxes, setTaxes] = useState<GetCustomizeCar_customizeCar_prices_totalPrice_taxes[]>();

  useEffect(() => {
    const carTaxes = !loading && selectedCar.prices.totalPrice.find(price => price.taxes);
    setTaxes(carTaxes.taxes);
  }, [selectedCar, selectedFeatures]);

  const getFeaturesComponents = (section: ISection) => {
    const sectionFeatures = section.featuresList.features;
    if (section.categories.length || sectionFeatures?.length) {
      return (
        <SelectedFeatureCategoryList
          key={section.code}
          categories={section.categories}
          sectionName={section.label}
          sectionCode={section.code}
          sectionDisclaimerIndicative={section.disclaimerIndicative}
          sectionFeatures={sectionFeatures}
        />
      );
    }

    if (section.featuresList?.features?.length) {
      return (
        <SelectedFeaturesList
          key={section.code}
          featuresList={section.featuresList}
          sectionName={section.label}
          sectionCode={section.code}
          sectionType={section.attributes?.selectiontype}
          sectionDisclaimerIndicative={section.attributes?.disclaimerindicative}
          categoryPurpose={section.attributes.categorypurpose as CategoryPurpose}
        />
      );
    }

    return null;
  };

  return (
    <SectionStatesWrapper error={error} loading={loading}>
      {!!selectedFeatures.length && selectedFeatures.map(feature => getFeaturesComponents(feature))}
      {!!selectedMiscFeatures.featuresList.features.length && (
        <SelectedFeaturesList
          key={selectedMiscFeatures.code}
          featuresList={selectedMiscFeatures.featuresList}
          sectionName={selectedMiscFeatures.label}
          sectionCode={selectedMiscFeatures.code}
        />
      )}
      {!!selectedMiscOffers.featuresList.features.length && (
        <SelectedFeaturesList
          key={selectedMiscOffers.code}
          featuresList={selectedMiscOffers.featuresList}
          sectionName={selectedMiscOffers.label}
          sectionCode={selectedMiscOffers.code}
        />
      )}
      <FeesAndCharges loading={loading} taxes={taxes ?? []} />
      {!!basketDiscounts?.length && <Discounts loading={loading} discounts={basketDiscounts} />}
    </SectionStatesWrapper>
  );
};
export default SelectedFeaturesContainer;
